import { useNavigate } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import { PACKAGES, IMAGES } from "../../data/content";

export default function WaysToTravel() {
    const navigate = useNavigate();

    return (
        <section id="packages" className="section-pad pt-0" data-testid="packages-section">
            <div className="container-luxe">
                <Reveal className="mb-14 max-w-2xl">
                    <p className="eyebrow mb-5">Three Ways to Travel</p>
                    <h2 className="font-serif text-navy text-3xl sm:text-4xl lg:text-[2.75rem] leading-snug">
                        Choose your <span className="italic text-gold">way</span> to go
                    </h2>
                    <p className="mt-5 font-light leading-relaxed">
                        From independent and expertly planned, to fully private and entirely yours — one free
                        consultation decides which of these fits you best.
                    </p>
                </Reveal>

                <div className="grid gap-8 md:grid-cols-3">
                    {PACKAGES.map((p, i) => (
                        <Reveal key={p.name} delay={0.1 * i} className="h-full">
                            <article
                                data-testid={`package-card-${p.name.toLowerCase().replace(/\s/g, "-")}`}
                                className="group h-full flex flex-col bg-white border border-line transition-all duration-500 hover:border-gold/60 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-30px_rgba(21,35,64,0.35)]"
                            >
                                <div className="relative overflow-hidden">
                                    <img
                                        src={IMAGES[p.imageKey].src}
                                        alt={IMAGES[p.imageKey].alt}
                                        loading="lazy"
                                        className="h-44 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                    <span className="absolute top-4 left-4 font-serif italic text-cream text-2xl drop-shadow">{p.numeral}.</span>
                                    {p.tag && (
                                        <span
                                            className={`absolute top-4 right-4 px-3 py-1 text-[10px] tracking-[0.18em] uppercase ${
                                                p.tag === "Most Popular" ? "bg-gold text-navy" : "bg-navy text-gold border border-gold/50"
                                            }`}
                                            data-testid={`package-tag-${p.name.toLowerCase().replace(/\s/g, "-")}`}
                                        >
                                            {p.tag}
                                        </span>
                                    )}
                                </div>

                                <div className="flex flex-col flex-1 p-7">
                                    <h3 className="font-serif text-navy text-2xl">{p.name}</h3>
                                    <p className="mt-1.5 text-[11px] tracking-[0.18em] uppercase text-gold">{p.kicker}</p>
                                    <p className="mt-4 text-sm font-light leading-relaxed">{p.blurb}</p>

                                    <ul className="mt-5 space-y-2.5 flex-1">
                                        {p.includes.map((inc) => (
                                            <li key={inc} className="flex items-start gap-2.5 text-sm font-light text-navy/85">
                                                <Check size={15} className="text-gold mt-0.5 shrink-0" strokeWidth={2.5} />
                                                {inc}
                                            </li>
                                        ))}
                                    </ul>

                                    <p className="mt-6 pt-4 border-t border-line text-[13px] font-light leading-relaxed">
                                        <span className="text-forest font-normal tracking-[0.08em] uppercase text-[11px]">Ideal for — </span>
                                        {p.idealFor}
                                    </p>

                                    {p.link ? (
                                        <button
                                            data-testid="bespoke-card-link"
                                            onClick={() => navigate(p.link)}
                                            className="mt-5 inline-flex items-center gap-2 text-[12px] tracking-[0.16em] uppercase text-gold hover:text-navy transition-colors duration-300 w-fit"
                                        >
                                            Discover the Bespoke experience
                                            <ArrowRight size={14} />
                                        </button>
                                    ) : (
                                        <button
                                            data-testid={`package-enquire-${p.name.toLowerCase().replace(/\s/g, "-")}`}
                                            onClick={() => navigate("/", { state: { scrollTo: "contact" } })}
                                            className="mt-5 inline-flex items-center gap-2 text-[12px] tracking-[0.16em] uppercase text-navy/70 hover:text-gold transition-colors duration-300 w-fit"
                                        >
                                            Enquire
                                            <ArrowRight size={14} />
                                        </button>
                                    )}
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
